import classnames from 'classnames';
import styles from './index.module.less';
import { Icon } from '../../atoms/icon';
import { Size } from '../../../core/enums';
import { Typography } from '../../archived/typography';

export interface Props {
  onPrevClick: () => void;
  onNextClick: () => void;
  onDotClick: (n: 0 | 1 | 2) => void;
  prevClickAriaLabel: string;
  nextClickAriaLabel: string;
  firstDotAriaLabel: string;
  secondDotAriaLabel: string;
  thirdDotAriaLabel: string;
  text: string;
  activeIndex: 0 | 1 | 2;
}
export const CompareCarouselControls = ({
  onPrevClick,
  onNextClick,
  onDotClick,
  prevClickAriaLabel,
  nextClickAriaLabel,
  firstDotAriaLabel,
  secondDotAriaLabel,
  thirdDotAriaLabel,
  text,
  activeIndex,
}: Props) => {
  const dotAriaLabels = [
    firstDotAriaLabel,
    secondDotAriaLabel,
    thirdDotAriaLabel,
  ];
  return (
    <div className={styles.container}>
      <button aria-label={prevClickAriaLabel} onClick={onPrevClick}>
        <Icon
          directory="dls"
          imageName="dls-icon-left"
          className={styles.arrowButton}
          $size={Size.SM}
        />
      </button>
      <div>
        <Typography className={styles.text}>{text}</Typography>
        <div className={styles.dotContainer}>
          {([0, 1, 2] as const).map((curr) => (
            <button
              key={curr}
              className={classnames(styles.dot, {
                [styles.active]: curr === activeIndex,
              })}
              aria-label={dotAriaLabels[curr]}
              onClick={() => onDotClick(curr)}
            />
          ))}
        </div>
      </div>
      <button aria-label={nextClickAriaLabel} onClick={onNextClick}>
        <Icon
          directory="dls"
          imageName="dls-icon-right"
          className={styles.arrowButton}
          $size={Size.SM}
        />
      </button>
    </div>
  );
};
